// Lib Imports
import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Box, Text, Card, CardBody, CardHeader } from 'grommet';
import PropTypes from 'prop-types';
import { FormDown } from 'grommet-icons';

// Core Imports
import Avatar from 'granite-admin/core/components/Avatar';
import Split from 'granite-admin/core/components/Split';
import Loader from 'granite-admin/core/components/Loader';
import { ConfigContext } from '../ConfigProvider';

// Application Imports
import { getAudits } from 'granite-admin/common/gateways/audits-api';
import AuditsSkeletonLoader from './components/AuditsSkeletonLoader';
const Audits = ({
  setShow,
  objectId,
  contentTypeName
}) => {
  const [nextPage, setNextPage] = useState(1);
  const [auditDataLog, setAuditDataLog] = useState([]);
  const [loader, setLoader] = useState(true);
  const fetchAuditsData = useCallback(page => {
    if (!page) return;
    setLoader(true);
    getAudits({
      target_content_type_name: contentTypeName,
      target_object_id: objectId,
      page
    }).then(response => {
      if (page === 1) setAuditDataLog(response.list);else setAuditDataLog(audits => [...audits, ...response.list]);
      setNextPage(response.nextPage);
    }).catch(err => console.log(err)).finally(() => setLoader(false));
  }, [contentTypeName, objectId]);
  useEffect(() => {
    fetchAuditsData(1);
  }, [fetchAuditsData]);
  return /*#__PURE__*/React.createElement(Split, {
    setShow: setShow,
    heading: "Audits",
    upperPane: /*#__PURE__*/React.createElement(AuditsRender, {
      data: auditDataLog,
      nextPage: nextPage,
      handleAuditsData: fetchAuditsData,
      loader: loader
    })
  });
};
const AuditsRender = ({
  data,
  nextPage,
  handleAuditsData,
  loader
}) => {
  const config = useContext(ConfigContext);
  return /*#__PURE__*/React.createElement(Box, {
    flex: "grow"
  }, !data.length && !loader ? /*#__PURE__*/React.createElement(Box, {
    flex: true,
    justify: "end",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xlarge"
  }, "No Audit Logs Created")) : data.map((x, index) => {
    return /*#__PURE__*/React.createElement(Box, {
      key: index + 'audit-card',
      pad: {
        vertical: 'small',
        horizontal: 'medium'
      }
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      pad: {
        bottom: 'small',
        horizontal: 'medium',
        top: 'medium'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      justify: "between",
      flex: true,
      align: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      gap: "small",
      align: "center"
    }, /*#__PURE__*/React.createElement(Avatar, {
      background: "border",
      round: "full",
      height: "xxsmall",
      width: "xxsmall",
      src: x?.profileImage
    }), /*#__PURE__*/React.createElement(Text, {
      size: "large"
    }, `${x.updatedBy}`)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, null, x.date)))), /*#__PURE__*/React.createElement(CardBody, {
      pad: "medium"
    }, Object.keys(x['new_data']).map(item => {
      return /*#__PURE__*/React.createElement(Box, {
        key: item,
        style: {
          overflowWrap: 'break-word'
        }
      }, /*#__PURE__*/React.createElement(Text, {
        size: "medium",
        color: "black"
      }, "Updated ", /*#__PURE__*/React.createElement("b", null, String(item).capitalize()), ": from '", typeof x.old_data[item] === 'string' ? x.old_data[item] : JSON.stringify(x.old_data[item]), "' to '", typeof x.new_data[item] === 'string' ? x.new_data[item] : JSON.stringify(x.new_data[item]), "'"));
    }))));
  }), loader && config?.showSkeletonLoader ? /*#__PURE__*/React.createElement(AuditsSkeletonLoader, null) : loader ? /*#__PURE__*/React.createElement(Box, {
    margin: {
      vertical: 'medium'
    },
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "30px"
  })) : nextPage && /*#__PURE__*/React.createElement(Box, {
    flex: {
      shrink: 0
    },
    alignSelf: "center",
    align: "center",
    onClick: () => handleAuditsData(nextPage),
    margin: "xsmall"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "info"
  }, "Load more"), /*#__PURE__*/React.createElement(FormDown, {
    size: "small",
    color: "info"
  })));
};
Audits.propTypes = {
  setShow: PropTypes.func,
  objectId: PropTypes.number,
  contentTypeName: PropTypes.string
};
AuditsRender.propTypes = {
  data: PropTypes.array,
  nextPage: PropTypes.number,
  loader: PropTypes.bool,
  handleAuditsData: PropTypes.func
};
export default Audits;